export const SUBSCRIPTION_OPTIONS = [
    {
        type: 'marketing',
        reason: 'Я согласен получать рекламно-информационные материалы',
    },
    {
        type: 'webinars',
        reason: 'Я хочу получать приглашения на бесплатные вебинары',
    },
] as const

export type SubscriberItem = {
    subscribe: boolean
    reason: string
    type: string
}

export function normalizeSubscriberItems(items: any, defaultSubscribe = false): SubscriberItem[] {
    const source = Array.isArray(items) ? items : []

    return SUBSCRIPTION_OPTIONS.map((option) => {
        const item = source.find((current: any) => current?.type === option.type)

        return {
            subscribe: typeof item?.subscribe === 'boolean' ? item.subscribe : defaultSubscribe,
            reason: option.reason,
            type: option.type,
        }
    })
}
